import type { ITaskTemplateSection, ITaskTemplateSectionRow } from '@/interfaces'
import TaskTemplateSectionRow from './TaskTemplateSectionRow'

class TaskTemplateSection implements ITaskTemplateSection {
  id?: string

  title: string

  description: string

  allowNewRowsAdditions?: boolean

  rows: ITaskTemplateSectionRow[]

  constructor(section?: any, isGetRequest?: boolean) {
    this.id = section?.id
    this.title = section?.title ?? ''
    this.description = section?.description ?? ''
    this.allowNewRowsAdditions = section?.allowNewRowsAdditions ?? false
    this.rows = section?.rows?.map((row: any) => new TaskTemplateSectionRow(row, isGetRequest)) ?? []
  }
}

export default TaskTemplateSection
